/**
 * toto musi byt v samostatnom subore kvoli ES6 import hoistingu
 */
__webpack_public_path__ = window.__staticAssetsPath__;
